import { AlertCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { ConfirmDialog } from "shared/components/modals/ConfirmDialog";

interface TurnOffAiSummaryDialogProps {
  opened: boolean;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const TurnOffAiSummaryDialog = ({
  opened,
  loading,
  onClose,
  onConfirm
}: TurnOffAiSummaryDialogProps) => (
  <ConfirmDialog
    opened={opened}
    onClose={onClose}
    onConfirm={onConfirm}
    variant="primary"
    icon={{ icon: AlertCircleIcon }}
    title="Turn off AI summary?"
    description="You can always turn it back on in your personal settings"
    confirmButton={{ label: "Turn off", loading }}
    showCloseButton
    // Sits on top of the explain-recommendation modal (z-50).
    zIndex={60}
  />
);
